import { ColumnDef } from '@tanstack/react-table'
import { GetDepositPromotionResponseData } from '@/modules/promotion/type'

import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { Pencil } from 'lucide-react'
import { DeleteAlert } from './CellAction/components/DeleteAlert'
import { IsActiveDepositPromotion } from './CellAction/components/IsActiveDepositPromotion'

export const columns: ColumnDef<GetDepositPromotionResponseData>[] = [
	{
		accessorKey: 'name',
		header: 'รายการโปรโมชั่น',
		cell: ({ row }) => <p className="font-medium">{row.original.name}</p>,
	},
	{
		accessorKey: 'details',
		header: 'รายละเอียด',
		cell: ({ row }) => {
			let promotionType = 'โปรสำหรับช่องทาง'
			if (row.original.isCoupon) {
				promotionType = 'คูปอง/แคมเปญ'
			} else if (row.original.isForPlayer) {
				promotionType = 'โปรสำหรับผู้เล่น'
			}

			return (
				<div className="space-y-1 text-sm">
					<p>{promotionType}</p>
					<p
						className={
							row.original.allowInstantClaim
								? 'text-xs text-green-600'
								: 'text-xs text-muted-foreground'
						}
					>
						รับฟรีทันที: {row.original.allowInstantClaim ? 'เปิด' : 'ปิด'}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'startDate',
		header: 'ช่วงเวลา',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p>
					เริ่ม:{' '}
					{row.original.startDate
						? new Date(row.original.startDate).toLocaleString()
						: 'ไม่มีกำหนด'}
				</p>
				<p className="font-medium">
					สิ้นสุด:{' '}
					{row.original.endDate
						? new Date(row.original.endDate).toLocaleString()
						: 'ไม่มีกำหนด'}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'dateInfo',
		header: 'วันที่สร้าง/แก้ไข',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p>สร้าง: {new Date(row.original.createdAt).toLocaleString()}</p>
				<p className="font-medium">
					แก้ไข: {new Date(row.original.updatedAt).toLocaleString()}
				</p>
			</div>
		),
	},
	{
		id: 'actions',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<div className="flex flex-wrap items-center gap-1">
				<IsActiveDepositPromotion row={row.original} />
				<Link to={`/operator/deposit-promotion/${row.original.id}`}>
					<Button variant="ghost" size="icon">
						<Pencil className="h-4 w-4" />
					</Button>
				</Link>
				<DeleteAlert id={row.original.id} />
			</div>
		),
	},
]

export const writeAccessorKeys = ['id']
